import { Route } from 'react-router-dom';
import ApplicantHome from 'src/views/applicant/Onboarding/home/home';
import BiometricsApplicant from 'src/views/applicant/Onboarding/onboarding_bio_satws/Biometrics';
import PhoneConfirmation from 'src/views/applicant/Onboarding/onboardingPhone/phoneConfirmation';
import CreditInformation from 'src/views/applicant/Onboarding/onboarding_creditInfo/creditInformation';
import { AllowedUser } from 'src/routes/ProtectedRoute';
import Simaf from 'src/views/applicant/Onboarding/onboarding_simaf/simaf';
import { ProtectedOnboardingRoute } from 'src/components/shared/compositionComponents/ProtectedOnboardingRoute/ProtectedOnboardingRoute';

const AllowedUserConfig: AllowedUser = {
  user: 'applicant',
  person: undefined
};

export const OnboardingApplicantRoutes = (
  <Route path="/solicitante">
    <Route index element={<ApplicantHome />} />
    <Route
      path="onboarding-data"
      element={
        <ProtectedOnboardingRoute allowedUsers={[AllowedUserConfig]}>
          <BiometricsApplicant />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="onboarding-creditInfo"
      element={
        <ProtectedOnboardingRoute allowedUsers={[AllowedUserConfig]}>
          <CreditInformation />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="onboarding-perfil-uso"
      element={
        <ProtectedOnboardingRoute allowedUsers={[AllowedUserConfig]}>
          <Simaf />
        </ProtectedOnboardingRoute>
      }
    />
    <Route
      path="onboarding-phone"
      element={
        <ProtectedOnboardingRoute allowedUsers={[AllowedUserConfig]}>
          <PhoneConfirmation />
        </ProtectedOnboardingRoute>
      }
    />
  </Route>
);
